<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<card-component class="has-table has-mobile-sort-spaced" :hasButtonSlot="true" title="一覧（ドラッグ＆ドロップで表示順序を変更できます）" icon="format-list-bulleted">
			<b-button slot="button" type="is-success" @click="$router.push({ name: 'coin-new' })">新規作成</b-button>

			<b-table
				:loading="isLoading"
				:paginated="false"
				:striped="true"
				:hoverable="true"
				:data="list"
				draggable
				@dragstart="dragstart"
				@drop="drop"
				@dragover="dragover"
				@dragleave="dragleave"
				>

				<template slot-scope="props">
					<b-table-column label="画像" field="image">
						<img class="image-preview" :src="props.row.image"/>
					</b-table-column>
					<b-table-column label="コイン名" field="name">
						{{ props.row.name }}
					</b-table-column>
					<b-table-column label="親コイン名" field="parent_name">
						{{ props.row.parent_name }}
					</b-table-column>
					<b-table-column label="カラー" field="color">
						<div class="list-color-sample" :style="{ 'background': props.row.color }"></div>
					</b-table-column>
					<b-table-column label="単位" field="unit">
						{{ props.row.unit }}
					</b-table-column>
					<!--
					<b-table-column label="獲得レート" field="recieve_rate">
						{{ props.row.recieve_rate}}
					</b-table-column>
					<b-table-column label="贈呈レート" field="present_rate">
						{{ props.row.present_rate}}
					</b-table-column>
					-->
					<b-table-column label="有効" field="is_active" centered>
						<b-icon type="is-success" icon="check" v-if="props.row.is_active"></b-icon>
					</b-table-column>

					<b-table-column label=" ">
						<div class="buttons is-right">
							<button class="button is-small is-warning" type="button" @click="$router.push({ name: 'coin-edit', params: { coinId: props.row.id }})">編集</button>
							<button class="button is-small is-danger" type="button" @click="onDeleteClick(props.row.id)">削除</button>
						</div>
					</b-table-column>
				</template>

				<section class="section" slot="empty">
					<table-empty :loading="isLoading"></table-empty>
				</section>
			</b-table>
		</card-component>
	</div>

</template>

<style lang="scss" scoped>
.image-preview {
	width: 30px;
	height: auto;
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import TableEmpty from '@/components/TableEmpty'
import PageInfo from '@/components/PageInfo'
import SearchBar from '@/components/SearchBar'
import DatePicker from '@/components/DatePicker'

export default {
	name: 'Coin',
	components: {
		TitleBar,
		CardComponent,
		TableEmpty,
		PageInfo,
		SearchBar,
		DatePicker,
	},
	data() {
		return {
			isLoading: false,
			list: [],
			draggingRow: null,
			draggingRowIndex: null,
		}
	},
	computed: {
		titleStack () {
			return [
				'コイン管理'
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		dragstart (payload) {
			this.draggingRow = payload.row
			this.draggingRowIndex = payload.index
			payload.event.dataTransfer.effectAllowed = 'copy'
		},
		dragover(payload) {
			payload.event.dataTransfer.dropEffect = 'copy'
			payload.event.target.closest('tr').classList.add('is-selected')
			payload.event.preventDefault()
		},
		dragleave(payload) {
			payload.event.target.closest('tr').classList.remove('is-selected')
			payload.event.preventDefault()
		},
		drop(payload) {
			payload.event.target.closest('tr').classList.remove('is-selected')
			const droppedOnRowIndex = payload.index
			//this.$buefy.toast.open(`Moved ${this.draggingRow.name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`)

			if (this.draggingRowIndex === droppedOnRowIndex) return;

			this.reorder(this.draggingRowIndex, droppedOnRowIndex);
		},
		reorder: async function(from, to) {
			let tmpList = this.list;
			let target = tmpList.splice(from, 1);
			Array.prototype.splice.apply(tmpList, [to, 0].concat(target));

			this.isLoading = true;
			let data = [];
			for (let i in tmpList) {
				data.push({
					"id": tmpList[i].id,
					"ordering": Number(i) + 1,
				});
			}

			this.$utils.log(data);

			try {
				let ep = 'coins/reorder';
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('表示順を更新しました');
				this.list = [];
				this.list = tmpList;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			this.isLoading = true;
			let ep = 'coins';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.list = res.data.list;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onDeleteClick: async function(id) {
			if (!window.confirm(this.$consts.MSG_CONFIRM_DELETE)) {
				return false;
			}

			this.isLoading = true;
			let ep = 'coins/' + id;
			this.$utils.log(ep);

			try {
				let res = await this.$api.delete(ep, null, true);
				this.$utils.log(res);
				this.list.some(function(v, i){
					if (v.id === id) this.list.splice(i, 1);
				}, this);
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
	},
}
</script>
